import { Controller } from '@hotwired/stimulus';
import { find, template } from 'lodash';

const TEMPLATE = template(`
<div class="pagadores-relacionados">
  <table class="table table-striped">
    <thead>
      <tr>
        <th class="col-icon-1"></th>
        <th><%= I18n.t("Pagador") %></th>
        <th><%= I18n.t("parentesco") %></th>
        <th>%</th>
      </tr>
    </thead>
    <tbody>
      <% if (_.isEmpty(objects)){ %>
        <tr>
          <td colspan="4">
            <%= I18n.t('no_pagado_valido') %>
          </td>
        </tr>
      <% } else { %>
        <% _.each(objects, function(pagador){ %>
          <tr>
            <td>
              <div class="pretty p-icon">
                <input type="radio" name="pagador_id" value="<%= pagador.id %>" id="pagador-<%= pagador.id %>">
                <div class="state p-cifra">
                  <i class="icon fa fa-check"></i>
                  <label></label>
                </div>
              </div>
            </td>
            <td>
              <label for="pagador-<%= pagador.id %>" class="clickable">
                <%= pagador.nombre_completo %>
              </label>
            </td>
            <td><%= pagador.relacion %></td>
            <td><%= pagador.porcentaje ? pagador.porcentaje + '%' : ''%></td>
          </tr>
        <% }); %>
      <% } %>
    </tbody>
  </table>
</div>
`);

/**
 * Modal de creación de nueva factura
 */
/* global $ */
export default class extends Controller {
  connect() {
    const $modal = $(this.element);

    this.initializeJqueryChained();

    $modal.find('#gestion_economica_factura_usuario_id').on('change', () => {
      const $alumno = $modal.find('.gestion_economica_factura_usuario_id');
      const alumnoId = $alumno.find(':selected').val();
      const url = `/gestion_economica/pagadores/${alumnoId}/relacionados`;
      $.get(url).done((data) => {
        const $wrapper = $modal.find('#wrapper-pagadores');
        let seleccionado;
        $wrapper.html(TEMPLATE({ objects: data }));

        seleccionado = find(data, { porcentaje: 100 });
        // Si solo hay uno, le seleccionamos
        if (!seleccionado && data.length === 1) {
          // eslint-disable-next-line prefer-destructuring
          seleccionado = data[0];
        }

        if (seleccionado) {
          $modal.find(`[name="pagador_id"][value="${seleccionado.id}"]`).prop('checked', true);
        }
      });
    });
  }

  initializeJqueryChained() {
    const $wrapper = $(this.element);
    $wrapper.find('select[data-chained]').each(function cada() {
      const $select = $(this);
      $select.chained($select.data('chained'));
    });
  }
}
